import { colors } from './colors';
import { type MapColorTheme } from './map-theme';

export const DEFAULT_THEME = {
  name: 'Default',
  complete: {
    light: colors.blue._400(),
    dark: colors.blue._600(),
  },
  complete_selected: {
    light: colors.blue._600(),
    dark: colors.blue._800(),
  },
  incomplete: {
    light: colors.red._800(),
    dark: colors.red._900(),
  },
  incomplete_selected: {
    light: colors.red._900(),
    dark: colors.red._700(),
  },
  selected_bounds: {
    light: colors.amber._700(),
    dark: colors.amber._500(),
  },
  bounds: {
    light: colors.zinc._700(),
    dark: colors.zinc._500(),
  },
  bounds_progress_min: {
    light: colors.red._200(),
    dark: colors.red._800(),
  },
  bounds_progress_mid: {
    light: colors.indigo._300(),
    dark: colors.indigo._700(),
  },
  bounds_progress_max: {
    light: colors.green._700(),
    dark: colors.green._300(),
  },
  hover: {
    light: colors.amber._200(),
    dark: colors.slate._700(),
  },
  city_selection_halo: {
    light: colors.amber._300(),
    dark: colors.stone._400(),
  },
  water: {
    light: colors.slate._300(),
    dark: colors.slate._800(),
  },
  waterway: {
    light: colors.slate._300(),
    dark: colors.slate._800(),
  },
  land: {
    light: colors.zinc._100(),
    dark: colors.zinc._950(),
  },
  building: {
    light: colors.zinc._300(),
    dark: colors.zinc._900(),
  },
  building_outline: {
    light: colors.zinc._500(),
    dark: colors.slate._900(),
  },
  road: {
    light: colors.zinc._200(), // Changed from _100 to _200 for better visibility
    dark: colors.zinc._900(),
  },
  bridge_outline: {
    light: colors.zinc._300(),
    dark: colors.zinc._100(),
  },
  road_outline: {
    light: colors.zinc._200(),
    dark: colors.zinc._800(),
  },
  road_exclude: {
    light: colors.zinc._200(),
    dark: colors.zinc._900(),
  },
  bridge_exclude_outline: {
    light: colors.zinc._400(),
    dark: colors.zinc._700(),
  },
  road_exclude_outline: {
    light: colors.zinc._300(),
    dark: colors.zinc._800(),
  },
  roadText: {
    light: colors.zinc._50(),
    dark: colors.zinc._50(),
  },
  roadHalo: {
    light: colors.zinc._950(),
    dark: colors.zinc._800(),
  },
  peaks: {
    light: colors.brown._400(),
    dark: colors.brown._500(),
  },
} as const satisfies MapColorTheme;
export const COLORBLIND_THEME = {
  ...DEFAULT_THEME,
  name: 'Colorblind Friendly',
  complete: {
    light: colors.blue._800(), // Darker blue for better contrast in light mode for BCM
    dark: colors.blue._900(), // Very dark blue for dark mode for BCM
  },
  complete_selected: {
    light: colors.blue._900(), // Even darker blue for selected in light mode
    dark: colors.blue._950(), // Darkest blue for selected in dark mode
  },
  incomplete: {
    light: colors.yellow._600(), // Darker gray for better contrast with background streets
    dark: colors.yellow._700(), // Darker gray for better contrast in dark mode
  },
  incomplete_selected: {
    light: colors.yellow._700(), // Even darker gray for selected in light mode
    dark: colors.yellow._800(), // Darkest gray for selected in dark mode
  },
  bounds: {
    light: colors.zinc._800(),
    dark: colors.zinc._500(),
  },
  selected_bounds: {
    light: colors.zinc._600(),
    dark: colors.zinc._500(),
  },
  hover: {
    light: colors.zinc._600(), // Slightly lighter than bounds for light mode
    dark: colors.zinc._400(), // Slightly lighter than bounds for dark mode
  },
} as const satisfies MapColorTheme;
export const AllThemes = [DEFAULT_THEME, COLORBLIND_THEME] as const;
export const ThemeNames = AllThemes.map(t => t.name);
export type ThemeName = (typeof ThemeNames)[number];
